export const MAX_STEPS = 7;
export const MIN_STEPS = 2;

export const Type = {
  Circle: 'circle',
  Text: 'text',
};

export const StepType = {
  Normal: 'normal',
  Error: 'error',
  Disabled: 'disabled',
  Completed: 'completed',
};

export const FitMode = {
  Compact: 'compact',
  Stretched: 'stretched',
};

export const DataHook = {
  Step: 'stepper-step',
  StepText: 'stepper-step-text',
};
